import FieldsValidation from '@components/Form/validationform/FieldsValidation';
import { TypesValidation } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Form, Icon } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React from 'react';

import IExecutionComponent from '../interfaces/IExecutionComponent';


export interface ITextExecutionProps extends IExecutionComponent {
  description: string;
  singleLine: boolean;
  repeat: boolean;
  required: boolean
  minRepeat: number;
  maxRepeat: number;
}

interface ITextExecutionState {
  textComponent: any;
  valid: boolean[];
}
export default class TextExecutionComponent extends React.Component<ITextExecutionProps, ITextExecutionState> {
  constructor(props: ITextExecutionProps) {
    super(props);

    this.state = {
      textComponent: [{ value: "" }],
      valid: [true]
    }
  }

  componentDidMount = async () => {
    await this.initialFields();
    const { defaultValue } = this.props;
    if (defaultValue && defaultValue.length > 0) {
      this.setState({textComponent: defaultValue.map(v => ({value: v}))})
    }
  }
  componentDidUpdate(prevProps: any, prevState: any) {
    if (JSON.stringify(prevState.textComponent) !== JSON.stringify(this.state.textComponent)) {
      let valid = this.validateFunction(this.state.textComponent)
      this.setState({ valid: valid })
      this.props.onChange(
        {
          id: this.props.id,
          value: this.state.textComponent.map((e: any) => e.value),
          validation: !valid.includes(false),
        }
      )
    }
  }
  initialFields = async () => {
    let i = 0;
    let textInitial = []
    if (this.props.repeat) {
      while (i < this.props.minRepeat) {
        textInitial.push(
          { value: "" }
        )
        i++;
      }
      textInitial.length > 0 && this.setState({ textComponent: textInitial })
    }
  }
  //#region  START HANDLES 
  handleInputChange = (idx: any) => async (evt: any) => {
    const newInputText = this.state.textComponent.map((items: any, sidx: number) => {
      if (idx !== sidx) return items;
      return { ...items, value: evt.target.value };
    });
    this.setState({ textComponent: newInputText })
  }

  validateFunction(inputText: any) {
    return inputText.map((t: any) => t.value.length >= 3)
  }

  handleAddTexts = async () => {
    let newTextComponent = [...this.state.textComponent, { value: '' , new : true}]
    this.setState({
      textComponent: newTextComponent,
    })
  }

  handleRemoveTexts = (index: number) => async () => {
    this.setState({
      textComponent: this.state.textComponent.filter((section: any, sindex: number) => index !== sindex),
    });
  }
  //#endregion
  deleteIcon(index: number) {
    return (
      <Icon
        style={{ color: 'red', marginLeft: '20px', cursor: "pointer" }}
        type="close"
        onClick={this.handleRemoveTexts(index)}
      />
    )
  }

  getFieldDefaultValue(fieldIndex: number) {
    const { defaultValue } = this.props;
    const { textComponent } = this.state;

    if (defaultValue) {
      if (defaultValue[fieldIndex]) {
        if(textComponent[fieldIndex].new) return ''
        return defaultValue[fieldIndex];
      }
    }
    return '';
  }

  render() {
    return (
      <Wrapper>
        <Form>
          <p>{this.props.description}</p>
          <FormItem>
            {this.state.textComponent.map((items: any, index: number) => (
              <div key={this.props.id + index} style={{ paddingBottom: '1rem' }}>
                <FieldsValidation
                  type={!this.props.singleLine ? TypesValidation.TEXAREA : TypesValidation.INPUT}
                  validation={this.props.required ? this.state.valid[index] : true}
                  handleOnChange={this.handleInputChange(index)}
                  messageValidation={this.props.required ? I18n.l("common.fieldRequired") : ''}
                  innerItems={this.props.repeat && this.props.minRepeat < this.state.textComponent.length ? this.deleteIcon(index) : <span />}
                  defaultValue={this.getFieldDefaultValue(index)}
                />
              </div>
            ))}
          </FormItem>
          {(this.props.repeat && this.props.maxRepeat > this.state.textComponent.length) &&
            < Button
              onClick={this.handleAddTexts}
              style={{ marginLeft: '-15px', fontWeight: 'bold' }}
              className="goepik-btn-border-main-withoutbold"
            >
              <Icon type="plus" /> {I18n.l("common.addNew")}
            </Button>
          }
        </Form>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  .button-style{
    margin-right: 20px;
    margin-bottom: 8px;
  }
`